import { STextBody } from 'containers/Enrollment/BenefitsWizard/styles'
import React, { forwardRef } from 'react'

import { SxStyleProp, TextProps } from 'rebass'
import ConditionalRender from 'utils/conditionalRender'

import STooltip from './STooltip'

interface Props extends TextProps {
    maxLines?: number
    tooltip?: string
    text: string
    listStyle?: string
    tooltipImage?: string
    textStyle?: SxStyleProp
}

const STextWithTooltip = forwardRef<any, Props>((props: Props, ref) => {
    return (
        <li style={{ listStyleType: props.listStyle || 'none' }}>
            <STextBody
                dangerouslySetInnerHTML={{
                    __html: props.text,
                }}
                sx={{
                    fontSize: 3,
                    fontWeight: 'regular',
                    color: 'gray400',
                    lineHeight: 1.4,
                    display: 'inline',
                    ...props.textStyle,
                }}
            />

            <ConditionalRender if={props.tooltip}>
                <STooltip
                    content={props.tooltip}
                    sy={{ display: 'inline', marginLeft: '10px' }}
                    tooltipImage={props.tooltipImage}
                />
            </ConditionalRender>
        </li>
    )
})

STextWithTooltip.displayName = 'STextWithTooltip'

export default STextWithTooltip
